const ContactType = {
  PRIMARY: "Primary",
  TREASURER: "Treasurer",
  DELEGATE: "Delegate",
};

export default ContactType;
